import {
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Button, Input } from "../../../../../controls";
import { Model, UseForm } from "../../../../../hooks";
import { Alert, Form } from "../../../../../layout";
import { ArrowBackRounded } from "@mui/icons-material";
import { API, action, controller } from "../../../../../api/api";
import {
  MaxLength,
  RmvEmptyProp,
  ToFormData,
} from "../../../../../hooks/Method";
import { AppContext } from "../../../../../App";

const AddSplrForm = (props) => {
  const { setShowForm, splrName, handleResult } = props;
  const { SupplierMdl } = Model();
  const { values, errors, setErrors, handleInpChg, setValues } =
    UseForm(SupplierMdl);
  const { authUser } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    splrName && setValues((j) => ({ ...j, splrName, defMarkup: 0 }));
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [splrName]);

  const validateForm = () => {
    let temp = {};
    temp.splrName = values.splrName !== "" ? "" : "Supplier name is required.";
    temp.defMarkup = values.defMarkup !== "" ? "" : "Markup is required.";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res && handleResult && res.status === 201) handleResult(res.result);
        else
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
      };
      values.orgId = authUser.orgId;
      values.userId = authUser.id;
      API(controller.Supplier + action.Post).post(
        ToFormData(RmvEmptyProp(values)),
        onComplete
      );
    }
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper>
          <div className="mb-[10px] flex justify-between items-center !pt-[15px] !pl-[15px] !pr-[15px]">
            <div className="flex items-center gap-[10px]">
              <div>
                <IconButton size="small" onClick={() => setShowForm(false)}>
                  <ArrowBackRounded />
                </IconButton>
              </div>
              <div>
                <h1 className="text-[20px] font-medium text-gray-500 uppercase">
                  Add Supplier
                </h1>
              </div>
            </div>

            <div>
              <Button type="submit" loading={loading}>
                Submit
              </Button>
            </div>
          </div>
          <Divider />
          <Grid container spacing={2.5} className="p-[15px] pt-[25px]">
            <Grid item xs={12}>
              <Input
                label="Supplier Name"
                name="splrName"
                required={true}
                value={values.splrName}
                error={errors.splrName}
                inputProps={{ maxLength: 255 }}
                onChange={handleInpChg}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label="Default Markup"
                name="defMarkup"
                required={true}
                value={values.defMarkup}
                error={errors.defMarkup}
                onChange={handleInpChg}
                onInput={(e) => (e.target.value = MaxLength(e.target.value, 4))}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">%</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label="Company"
                name="company"
                value={values.company}
                error={errors.company}
                onChange={handleInpChg}
                inputProps={{ maxLength: 200 }}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label="Phone"
                name="phone"
                value={values.phone}
                error={errors.phone}
                inputProps={{ maxLength: 50 }}
                onChange={handleInpChg}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label="Description"
                name="desc"
                value={values.desc}
                error={errors.desc}
                inputProps={{ maxLength: 1500 }}
                multiline
                rows={3}
                onChange={handleInpChg}
              />
            </Grid>
          </Grid>
        </Paper>
      </Form>
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </>
  );
};

export default AddSplrForm;
